import React, { useEffect, useState } from "react";
import HRHeader from "../components/HRHeader";
import api, { downloadPayslip } from "../api";
import { toast } from "sonner";
import { Download, FileText, Wallet, TrendingUp } from "lucide-react";

const euro = (v) => "\u20ac " + Number(v).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const BustePagaPage = () => {
  const [payslips, setPayslips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(null);

  useEffect(() => {
    api.get("/payslips/mine").then((r) => setPayslips(r.data)).catch(() => {}).finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDownload = async (p) => {
    setDownloading(p.id);
    try {
      await downloadPayslip(p.id, `cedolino_${p.year}_${String(p.month).padStart(2, "0")}.pdf`);
      toast.success(`Cedolino ${p.period} scaricato`);
    } catch (e) {
      toast.error("Errore durante il download");
    } finally {
      setDownloading(null);
    }
  };

  const latest = payslips[0];

  return (
    <div className="min-h-screen bg-[#f0f2f5]">
      <HRHeader />
      <main className="max-w-[1200px] mx-auto px-4 py-8">
        <h1 className="text-[26px] font-black text-[#16345c] mb-1">Buste Paga</h1>
        <p className="text-[14px] text-gray-500 mb-6">Consulta e scarica i tuoi cedolini in formato PDF</p>

        {latest && (
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            <div className="bg-gradient-to-br from-[#16345c] to-[#0d1b2f] text-white rounded-lg p-5">
              <div className="flex items-center gap-2 text-[12px] text-gray-300 mb-1"><Wallet size={15} /> Ultimo netto ({latest.period})</div>
              <div className="text-[28px] font-black">{euro(latest.net)}</div>
            </div>
            <div className="bg-white border border-gray-200 rounded-lg p-5">
              <div className="flex items-center gap-2 text-[12px] text-gray-500 mb-1"><TrendingUp size={15} /> Ultimo lordo</div>
              <div className="text-[28px] font-black text-[#16345c]">{euro(latest.gross)}</div>
            </div>
            <div className="bg-white border border-gray-200 rounded-lg p-5">
              <div className="flex items-center gap-2 text-[12px] text-gray-500 mb-1"><FileText size={15} /> Cedolini disponibili</div>
              <div className="text-[28px] font-black text-[#16345c]">{payslips.length}</div>
            </div>
          </div>
        )}

        <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
          <div className="grid grid-cols-12 px-5 py-3 bg-[#16345c] text-white text-[12px] font-bold uppercase tracking-wide">
            <div className="col-span-5">Periodo</div>
            <div className="col-span-3 text-right hidden sm:block">Lordo</div>
            <div className="col-span-4 sm:col-span-2 text-right">Netto</div>
            <div className="col-span-3 sm:col-span-2 text-right">Azioni</div>
          </div>
          {loading ? (
            <div className="p-10 text-center text-gray-400">Caricamento...</div>
          ) : payslips.length === 0 ? (
            <div className="p-10 text-center text-gray-400">Nessun cedolino disponibile</div>
          ) : (
            payslips.map((p) => (
              <div key={p.id} className="grid grid-cols-12 items-center px-5 py-3.5 border-b border-gray-100 last:border-0 hover:bg-gray-50 transition-colors">
                <div className="col-span-5 flex items-center gap-3">
                  <span className="w-9 h-9 rounded-lg bg-[#16345c]/10 text-[#16345c] flex items-center justify-center shrink-0"><FileText size={17} /></span>
                  <div>
                    <div className="text-[14px] font-bold text-[#16345c]">{p.period}</div>
                    {p.label && <div className="text-[11px] text-[#e30613] font-semibold">{p.label}</div>}
                  </div>
                </div>
                <div className="col-span-3 text-right text-[14px] text-gray-600 hidden sm:block">{euro(p.gross)}</div>
                <div className="col-span-4 sm:col-span-2 text-right text-[14px] font-bold text-[#16345c]">{euro(p.net)}</div>
                <div className="col-span-3 sm:col-span-2 flex justify-end">
                  <button onClick={() => handleDownload(p)} disabled={downloading === p.id}
                    className="flex items-center gap-1.5 bg-[#16345c] hover:bg-[#0d1b2f] text-white text-[12px] font-bold px-3 py-2 rounded-sm transition-colors disabled:opacity-60">
                    <Download size={14} /> <span className="hidden sm:inline">{downloading === p.id ? "..." : "PDF"}</span>
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </main>
    </div>
  );
};

export default BustePagaPage;
